<template>
    <div id="cuestionarios">
        <v-app>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="18" class="titulo">
                    Cuestionarios Evaluativos
                </el-col>
            </el-row>
            <el-row :gutter="20" type="flex" justify="center" align="middle">
                <el-col :span="22" class="cuerpo">
                    <v-alert type="error" color="red" :value="true">
                        Para poder aprobar, <strong>debe responder bien</strong> al menos <strong>5</strong> de las 7 <strong>preguntas</strong>.
                    </v-alert>
                    <v-alert type="warning" color="orange" :value="true">
                        Si no aprobó, se le otorga una oportunidad más.
                    </v-alert>
                    <br>
                    
                    <el-row>
                        <el-col :xs="24" :sm="12" style="background:#eee; border-radius:5px">
                            <v-text-field ref="Buscar" v-model="Search" append-icon="search" label="Buscar" single-line hide-details style="padding:10px"></v-text-field>
                        </el-col>
                    </el-row>
                    
                    <v-data-table :headers="Headers" :items="Comisiones" :search="Search" :pagination.sync="Pagination" style="margin-top:30px">

                        <template slot="no-data">
                                <el-col>
                                 <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>                                 
                                <el-col class="cargandomsg"> Cargando Datos </el-col>
                                </el-col>                               
                        </template>

                        <template slot="items" slot-scope="props">
                             <td colspan="4" class="no_results_msj" v-if="props.item.resultado==0">
                                No se encontraron resultados
                            </td>
                            <tr v-else>
                                <td>{{ props.item.idComision }} </td>
                                <td>{{ props.item.Nombre }}     </td>
                                <td>
                                    <center>
                                        <span v-if="props.item.Cantidad>6 && props.item.Aprobado"    class="Aprobado"   >Aprobado   </span> 
                                        <span v-if="props.item.Cantidad>6 && props.item.Desaprobado" class="Desaprobado">Desaprobado</span> 
                                        <router-link v-if="props.item.Abierta && props.item.Responder && !props.item.Recuperar && !props.item.Aprobado" class="el-button el-button--success el-button--mini" :to="'cuestionario/'+ props.item.idComisionEncriptada +''">Responder</router-link>
                                        <router-link v-if="props.item.Abierta && props.item.Responder && props.item.Recuperar  && !props.item.Aprobado" class="el-button el-button--success el-button--mini" :to="'cuestionario/'+ props.item.idComisionEncriptada +''">Recuperar</router-link>
                                    </center>
                                </td> 
                                <td>
                                    <center>
                                        <router-link v-if="props.item.Respondida" class="el-button el-button--info el-button--mini" :to="'cuestionario_respuestas/'+ props.item.idComisionEncriptada +''">Ver Respuestas</router-link>
                                    </center>
                                </td>                            
                            </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            No se encontraron resultados
                        </v-alert>
                    </v-data-table>
                </el-col>
            </el-row>
        </v-app>
    </div>
</template>



<script>
    import axios from 'axios'

    export default
    {   data()
        {   return {
                Comisiones: [],
                Search:     '',
                
                Pagination: { 
                    descending: true,
                    rowsPerPage: 10,
                    sortBy: 'id' 
                },
                Headers: [{
                        text: 'Com ',
                        value: 'idComision'
                    },
                    {
                        text: 'Capacitación ',
                        value: 'Nombre'
                    },
                    {
                        text: 'Responder ',
                        value: 'idComision'
                    },
                    {
                        text: 'Resultados ',
                        value: 'idComision'
                    }
                ],
            }
        },


        methods:
        {   
        },
        
        
        beforeMount( )
        {   if (!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/quest.php', params, {headers: headers})
                    .then(response => {
                        const datos     = response.data
                      if(datos==null)
                        {    
                            this.Comisiones     = [ {"resultado": 0}];                       
                        }
                        else
                        {
                            this.Comisiones = datos['Comisiones'];                            
                        }
                       
                            
                    })
                   /* .catch(e => {})*/
            }
        },


        mounted()
        {   this.$nextTick(this.$refs.Buscar.focus);
        }
    };
</script>



<style>
    .v-datatable thead tr th, .v-datatable thead tr td
    {   background: #00B5FF !important;
        text-align: center !important;
        color: #fff !important;
        font-weight: bold !important;
    }

    table tr:hover td
    {   background: #EEF1F6 !important;
    }

    .Aprobado
    {   padding: 7px 15px 7px 15px;
        background: green;
        color: #fff;
        font-weight: bold;
    }
    .Desaprobado
    {   padding: 7px 15px 7px 15px;
        background: red;
        color: #fff;
        font-weight: bold;
    }
   .no_results_msj
    {
        text-align: center;
        width: 100%!important;         
        font-weight: 600!important;        
    }
     .cargandomsg
    {
            font-weight: 600!important;
            padding-bottom: 1%!important;

    }
</style>